module.exports = __webpack_public_path__ + "static/media/icon-notification.716caef1.svg";